/**
 * @module config/form
 * @description Barrel export for form configuration
 */

export { default as formConfig } from './form';
export { default } from './form';
